import no from "./no";
import en from "./en";
import da from "./da";
import de from "./de";
import es from "./es";
import nl from "./nl";
import sv from "./sv";

/** All translation dictionaries, keyed by language code. */
export const locales = { no, en, da, de, es, nl, sv };

/** The base/fallback language (the app's original language). */
export const DEFAULT_LANG = "no";

/**
 * The languages shown in the switcher, in the order from the design.
 * `flag` is a Unicode flag emoji; `label` is the native name.
 */
export const LANGS = [
  { code: "da", label: "Dansk", flag: "🇩🇰" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "no", label: "Norsk", flag: "🇳🇴" },
  { code: "sv", label: "Svenska", flag: "🇸🇪" },
];
